import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaFolder, FaTimes } from "react-icons/fa";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";

export default function ClientFolder() {
  const [clients, setClients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };

  useEffect(() => {
    GetClients();
  }, []);

  const GetClients = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETALLCLIENTS + "?userId=" + userId, {
        ...headerconfig,
      })
      .then((response) => {
        setClients(response.data.data);
      });
  };
  const handleFolderClick = (clientId) => {
    navigate("/clientfolder/" + clientId);
  };

  const handleSearch = async (e) => {
    const searchItem = e.target.value;
    setSearchTerm(searchItem);

    if (!searchItem) {
      setSearchResults([]);
      setShowDropdown(false);
      return;
    }

    try {
      const response = await axios.get(
        config.APIACTIVATEURL + config.SEARCHFOLDERS,
        {
          params: { searchItem, userId: userId },
          headers: {
            ...headerconfig,
          },
        }
      );

      if (response.status === 200) {
        const combinedResults = [
          ...response.data.clients.map((client) => ({
            id: client.clientId,
            name: client.name,
            type: "Client",
            details: client.details,
          })),
          ...response.data.folders.map((folder) => ({
            id: folder.folderId,
            name: folder.name,
            type: "Folder",
            details: "-" + folder.clientName,
          })),
          ...response.data.documents.map((document) => ({
            id: document.documentId,
            name: document.name,
            subFolder: document.subFolder,
            type: "Document",
            details: "-" + document.clientName,
            imageSrc: document.imageSrc,
          })),
        ];
        setSearchResults(combinedResults);
        setShowDropdown(true);
      } else {
        console.error("Error fetching search results:", response.data);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setSearchResults([]);
    setShowDropdown(false);
  };

  const handleItemClick = (item) => {
    if (item.type === "Client") {
      navigate("/clientfolder/" + item.id);
    } else if (item.type === "Folder") {
      if (item.name.toLowerCase() === "main") {
        navigate("/folder/" + item.id);
      } else {
        navigate("/file/" + item.id);
      }
    } else if (item.type === "Document") {
      if (item.imageSrc) {
        window.open(item.imageSrc, "_blank");
      } else {
        navigate("/document/" + item.id);
      }
    }
  };

  const filteredClients = searchTerm
    ? clients.filter((client) =>
        client.clientName.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : clients;

  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Client Folders</h4>
                </div>
              </div>
            </div>

            <div className="row mt-6">
              <div className="col-12">
                <div className="p-3 border rounded shadow bg-white">
                  <div className="d-flex align-items-center">
                    <input
                      type="text"
                      className="form-control me-3"
                      style={{ maxWidth: "70%" }}
                      placeholder="Search.........."
                      value={searchTerm}
                      onChange={handleSearch}
                    />
                    <button
                      className="btn btn-danger me-2"
                      style={{ width: "120px" }}
                      type="button"
                      onClick={handleClearSearch}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {showDropdown && searchResults.length > 0 && (
              <div
                className="search-results"
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  marginBottom: "10px",
                }}
              >
                <ul className="list-group">
                  {searchResults.map((result, index) => (
                    <li
                      key={index}
                      className="list-group-item"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleItemClick(result)}
                    >
                      {result.name} ({result.type} {result.subFolder}{" "}
                      {result.details})
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="row">
                      {filteredClients.length > 0 ? (
                        filteredClients.map((client) => (
                          <div
                            key={client.clientId}
                            className="col-lg-3 col-md-4 col-sm-6 mb-4"
                            style={{ cursor: "pointer" }}
                          >
                            <div className="card text-center shadow-sm">
                              <div className="card-body">
                                <div
                                  className="folder-icon mb-3"
                                  onClick={() =>
                                    handleFolderClick(client.clientId)
                                  }
                                >
                                  <FaFolder size={40} color="#ff8c00" />
                                </div>
                                <div className="folder-name">
                                  {client.clientName}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="col-12">
                          <p colSpan="6" className="text-center">
                            No client folders available.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
